// Full-document render of the embeddable nav-only iframe page
// (/cms/frameutils/navigation/): the standard document shell with the footer
// slot suppressed, plus the iframe-resizer contentWindow script the legacy
// template added (config must be set before the script loads). Rendered
// before the body-end scripts, matching the legacy source order (resizer
// before legacy.js).
import React from "react";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton).
export const Template = (
    props: templates.NavIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <PageSkeleton pageChrome={props.page_chrome} footer={false}>
            <script
                dangerouslySetInnerHTML={{
                    __html: `window.iFrameResizer = { heightCalculationMethod: "lowestElement" };`,
                }}
            />
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
            />
        </PageSkeleton>
    );
};
